import StarterKit from "./StarterKit";

import AnimationFooter from "./components/AnimationFooter";
import BannerHome from "./components/BannerHome";
import BannerScroll from "./components/BannerScroll";
import ButtonsMagnet from "./components/ButtonMagnet";
import ButtonsMouseTrap from "./components/ButtonMouseTrap";
import CardHover from "./components/CardHover";
import CardsReveal from "./components/CardsReveal";
import FilterSelect from "./components/FilterSelect";
import Glow from "./components/Glow";
import Header from "./components/Header";
import Jobs from "./components/Jobs";
import Navs from "./components/Navs";
import OptimiseContrast from "./components/OptimizeContrast";
import Share from "./components/Share";
import SliderGrab from "./components/SliderGrab";

import BlockAcrostic from "./blocks/BlockAcrostic";
import BlockAgencies from "./blocks/BlockAgencies";
import BlockAnchor from "./blocks/BlockAnchor";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockCta from "./blocks/BlockCta";
import BlockMap from "./blocks/BlockMap";
import BlockMarquee from "./blocks/BlockMarquee";
import BlockMovie from "./blocks/BlockMovie";
import BlockRelatedPosts from "./blocks/BlockRelatedPosts";
import BlockServicesList from "./blocks/BlockServicesList";
import BlockTextSliderImages from "./blocks/BlockTextSliderImages";
import BlockTextAnimation from "./blocks/BlockTextAnimation";
import BlockTextCircle from "./blocks/BlockTextCircle";

window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	AnimationFooter.init();
	BannerHome.init();
	BannerScroll.init();
	ButtonsMagnet.init();
	ButtonsMouseTrap.init();
	CardHover.init();
	CardsReveal.init();
	FilterSelect.init();
	Glow.init();
	Header.init();
	Jobs.init();
	Navs.init();
	OptimiseContrast.init();
	Share.init();
	SliderGrab.init();

	// Blocks
	BlockAcrostic.init();
	BlockAgencies.init();
	BlockAnchor.init();
	BlockCollapse.init();
	BlockCta.init();
	BlockMap.init();
	BlockMarquee.init();
	BlockMovie.init();
	BlockRelatedPosts.init();
	BlockServicesList.init();
	BlockTextAnimation.init();
	BlockTextCircle.init();
	BlockTextSliderImages.init();


});
